import MaterialRateEdit from '@/components/material/rateedit/MaterialRateEdit.vue'

export default {
  name: 'MaterialRateHistory',
  components: {
    MaterialRateEdit
  },
  props: {
    data: Object,
    info: Object,
    isModal: Boolean
  },
  data () {
    return {
      clientApiId: null,
      materialCode: null,
      materialId: null,
      materialRates: [],
      loading: false,
      includeDefaultRates: 0
    }
  },
  computed: {
    componentName () {
      if (this.isModal) {
        return 'b-modal';
      }
      return 'div';
    },
    canEdit () {
      if (this.clientApiId) {
        if (this.includeDefaultRates) {
          return false;
        }
        return this.ApiRequest.userHasPermission('edit-clients');
      }
      return this.ApiRequest.userHasPermission('edit-settings');
    },
    title () {
      return this.$t('client.material-rates');
    },
    tableHeaders () {
      const headers = [
        { key: 'from_date_period_id', label: this.$t('material_rate.from_date_period_id'), format: 'formatDatePeriod' },
        { key: 'to_date_period_id', label: this.$t('material_rate.to_date_period_id'), format: 'formatDatePeriod' },
        { key: 'isAllowed', label: this.$t('material_rate.isAllowed'), format: 'formatYesNo' }
      ];
      if (this.includeDefaultRates && this.clientApiId) {
        headers.push({ key: 'defaultRate', label: this.$t('material.defaultRate'), format: 'formatDecimal', precision: 4 });
        headers.push({ key: 'clientRate', label: this.$t('material.clientRate'), format: 'formatDecimal', precision: 4 });
        headers.push({ key: 'discount', label: this.$t('material-group.discount'), format: 'formatPercent' });
        headers.push({ key: 'activeDiscount', label: this.$t('material.activeDiscount'), format: 'formatPercent' });
        headers.push({ key: 'activeRate', label: this.$t('material.activeRate'), format: 'formatDecimal', precision: 4 });
      } else {
        headers.push({ key: 'rate', label: this.$t('material.rate'), format: 'formatDecimal', precision: 4 });
        if (this.canEdit) {
          const actions = [
            { label: this.$t('menu.material-rate.edit'), emit: 'editMaterialRate', icon: 'edit', bicon: 'pencil-fill' },
            { label: this.$t('menu.material-rate.delete'), emit: 'deleteMaterialRate', icon: 'delete', bicon: 'trash' }
          ]
          headers.push({ key: 'actions', label: '', actions: actions });
        }
      }
      return headers;
    }
  },
  methods: {
    getTableData () {
      if (this.materialCode) {
        this.loading = true;
        const self = this;
        let path = 'material/material/rates/' + this.materialCode;
        if (this.clientApiId) {
          path = 'client/single/' + this.clientApiId + '/material-rates/item/' + this.materialCode + '/' + this.includeDefaultRates;
        }
        this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, function (response) {
          if (response.data) {
            self.materialRates = response.data;
          }
          self.loading = false;
        });
      }
    },
    editMaterialRate (rate) {
      this.$refs.materialRateEdit.show(rate, this.materialId);
    },
    deleteMaterialRate (rate, approved) {
      if (approved) {
        const self = this;
        let path = 'material/material/rates/' + self.materialCode + '/delete';
        if (self.clientApiId) {
          path = 'client/single/' + self.clientApiId + '/material-rates/item/' + self.materialCode + '/delete';
        }
        this.ApiRequest.request(path + '/' + rate.id, this.ApiRequest.REQUEST_POST, [], function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self)
          } else {
            self.materialsUpdated();
          }
        });
      } else {
        const fromPer = this.BasicHelper.datePeriodCodeToData(rate.from_date_period_id);
        const toPer = this.BasicHelper.datePeriodCodeToData(rate.to_date_period_id);
        const params = {
          material: this.BasicHelper.getConfigValue('materials', 'id', rate.material_id, 'name', true),
          from_period: (fromPer ? this.$tc('general.datePeriod.short', fromPer.period, fromPer) : ''),
          to_period: (toPer ? this.$tc('general.datePeriod.short', toPer.period, toPer) : '')
        }
        let messageTitle = this.$t('material-rates.deleteTitle');
        if (this.clientApiId) {
          messageTitle = this.$t('material-rates.deleteClientAction');
        }
        this.$refs.itemDeleteMsgBox.show(rate, messageTitle, this.$t('material-rates.deleteMessage', params))
      }
    },
    materialsUpdated () {
      this.$emit('saved');
      this.getTableData();
    },
    show (materialId, clientApiId) {
      this.materialId = materialId;
      this.clientApiId = clientApiId;
      this.materialCode = this.$store.getters.getParamFromConfig('materials', this.materialId, 'code');
      this.getTableData();
      this.$refs['modal-window'].show();
    }
  },
  mounted () {
    if (this.info && this.info.clientApiId) {
      this.clientApiId = this.info.clientApiId;
    }
    if (this.info && this.info.includeDefaultRates) {
      this.includeDefaultRates = this.info.includeDefaultRates;
    }
    if (this.data && this.data.material_id) {
      this.materialId = this.data.material_id;
      this.materialCode = this.$store.getters.getParamFromConfig('materials', this.materialId, 'code');
    }
    this.getTableData();
  }
}
